// Library Class
import * as $ from 'jquery';
import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild, AfterViewInit, OnDestroy, HostListener } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatTabChangeEvent } from '@angular/material/tabs';

import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { ConfirmDialogComponent } from '../../../common/components/confirm-dialog/confirm-dialog.component';
// Class
import { MasterConstants } from '../../../common/constants/master-constants';
import { CPPReturnsLandingFilterVM } from '../../../models/CPPReturns/CPPReturnsLandingFilterVM';
import { DashboardFilter } from '../../../models/DashboardFilter';
import { LoaderService } from '../../../services/infrastructure/loader.service';
import { CommonService } from '../../../services/common/common.service';
import { CppReturnsService } from '../../../services/cpp-returns/cpp-returns.service';
import { OTIOrderLandingFilterVM } from '../../../models/OTI/OTIOrderLandingFilterVM';
import { OtiService } from '../../../services/oti/oti.service';
// Service Class
import { LocalStorageService } from '../../../services/infrastructure/local-storage.service';
import { CppReturnAddProductSliderModelService } from '../../../common/components/cpp-return-add-product/cpp-return-product-slider-model.service';
import { ExcelService } from './../../../services/infrastructure/excel.service';
import { LolLoggerService } from '../../../common/shared/lol-logger.service';

@Component({
  selector: 'app-cpp-returns-dashboard',
  templateUrl: './cpp-returns-dashboard.component.html',
  styleUrls: ['./cpp-returns-dashboard.component.scss']
})

export class CppReturnsDashboardComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('returnRequestTable', { read: MatSort }) returnRequestSort: MatSort;
  @ViewChild('returnRequestPaginator', { read: MatPaginator }) returnRequestPaginator: MatPaginator;
  @ViewChild('returnRequestDraftTable', { read: MatSort }) returnRequestDraftSort: MatSort;
  @ViewChild('returnRequestDraftPaginator', { read: MatPaginator }) returnRequestDraftPaginator: MatPaginator;

  headerYear: any;
  draftRequestDataSource: MatTableDataSource<any>;
  returnRequestDataSource: MatTableDataSource<any>;
  resultant: any = [];
  returnRequestDraftList: any = [];
  filters: OTIOrderLandingFilterVM = new OTIOrderLandingFilterVM();
  returnRequestList: any = [];
  headerCompany = MasterConstants.US_COMPANYCODE;
  dashboardFilter: DashboardFilter;
  returnRequestDraftColumns: string[] = [];
  returnRequestColumns: string[] = [];
  accountList: any;
  selectedAccount: number;
  validateEvolveData: any;
  readOnlyAccess = false;
  userMenuAccessList: any;
  isEvolveAccountRestriction = false;
  selectedValue: string;
  filterValueList = new Array();
  searchTypeList: string[] = [];
  fromOrderDateFilter: any;
  toOrderDateFilter: any;
  productFilters: any;
  itemList: any = [];
  filter: CPPReturnsLandingFilterVM = new CPPReturnsLandingFilterVM();
  productLineList: any;
  ddlAccounts: any[] = [];
  isApprovalAccess = false;
  notificationList: any = [{ 'id': 'Comments', 'value': 'Comments' }, { 'id': 'ManualProducts', 'value': 'Manual Products' }, { 'id': 'Error', 'value': 'Error' }];
  bannerMessage = '';
  isValidForReturn = true;
  isOTIAccess = false;
  private subscription = new Subscription();
  public selectedTabIndex = 0;
  masterConstants = MasterConstants;
  productLine: string = "";
  productLine2: string = "";
  isProcessAccessed: Boolean = false;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private matDialog: MatDialog,
    private localStorageService: LocalStorageService,
    private loaderService: LoaderService,
    private toastrService: ToastrService,
    private datePipe: DatePipe,
    private cppReturnsService: CppReturnsService,
    private cppReturnAddProductSliderModelService: CppReturnAddProductSliderModelService,
    private commonService: CommonService,
    public excelService: ExcelService,
    private otiService: OtiService) {
    this.dashboardFilter = new DashboardFilter();
  }

  // page initilization code
  ngOnInit() {

    if (this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR)) {
      this.headerYear = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR));
    }
    if (this.localStorageService.get(MasterConstants.EVOLVE_ACCESS)) {
      this.validateEvolveData = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
      const sessionData = this.validateEvolveData.resultData.find(x => x.userIdCompanyCode == this.headerCompany);
      this.isEvolveAccountRestriction = sessionData.evolveAccountRestriction;

      if (this.headerCompany != undefined && this.isEvolveAccountRestriction == true) {
        this.subscription.add(this.commonService.getFilterDDLData().subscribe(result => {
          this.ddlAccounts = result.accounts;
        }, error => LolLoggerService.error(error)));
      }
      const evolveAccessData = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
      if (evolveAccessData) {
        this.userMenuAccessList = evolveAccessData.resultData.find(x => x.userIdCompanyCode == this.headerCompany).userMenuAccessList;
        this.readOnlyAccess = this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.CPP_RETURNS_PRODUCTS, this.masterConstants.USER_ACCESS.READ_ONLY, this.userMenuAccessList);
        this.isOTIAccess = this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.ORDER_TO_INVOICE);
      }
    }

    if (this.localStorageService.get(MasterConstants.CPP_RETURN_ITEM_NUMBER_MASTER_LIST)) {
      this.itemList = JSON.parse(this.localStorageService.get(MasterConstants.CPP_RETURN_ITEM_NUMBER_MASTER_LIST));
    } else {
      this.subscription.add(this.cppReturnsService.getItemNumberList().subscribe((result: any[]) => {
        this.localStorageService.set(MasterConstants.CPP_RETURN_ITEM_NUMBER_MASTER_LIST, JSON.stringify(result));
        this.itemList = result;
      }));
    }

    this.isApprovalAccess = this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.CPP_RETURNS_PRODUCTS);

    this.subscription.add(this.activatedRoute.paramMap.subscribe(x => {
      let productLineObject = x["params"]
      if (productLineObject["productLine"] == "Inoculant") {
        this.productLine = JSON.parse(this.localStorageService.get(MasterConstants.PRODUCT_LINE_INOCULANT_CODE));
        this.productLine2 = JSON.parse(`"${this.localStorageService.get(MasterConstants.PRODUCT_LINE_INOCULANT_CODE2)}"`);
        this.cppReturnsService.setIsReturnTypeForInoculant(true)
        this.returnRequestDraftColumns = ['returnRequestNumber', 'accountName', 'accountNumber', 'soldToNumber', 'purchaseOrderNumber', 'orderCreateDate', 'contextMenu'];
        this.returnRequestColumns = ['returnRequestNumber', 'accountName', 'accountNumber', 'soldToNumber', 'purchaseOrderNumber', 'orderCreateDate', 'status', 'contextMenu'];
      }
      else {
        this.productLine = "";
        this.productLine2 = "";
        this.cppReturnsService.setIsReturnTypeForInoculant(true)
        this.returnRequestDraftColumns = ['returnRequestNumber', 'accountName', 'accountNumber', 'purchaseOrderNumber', 'orderCreateDate', 'contextMenu'];
        this.returnRequestColumns = ['returnRequestNumber', 'accountName', 'accountNumber', 'purchaseOrderNumber', 'orderCreateDate', 'status', 'contextMenu'];
      }
      this.setSearchTypeList();
      this.resetPageFilter();
      this.clearAllFilter();
      this.getProductLineList();
      this.getBannerMessage();
      if (this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.CPP_RETURNS_PRODUCTS, this.masterConstants.USER_ACCESS.EDIT_FULL, this.userMenuAccessList)) {
        this.getProcessAccess();
      }
    }));
  }

  ngAfterViewInit() {
    // Set Dynamic Height of Panels
    this.setAccSummaryTableHeight();
  }

  // Tab changed
  tabChanged = (tabChangeEvent: MatTabChangeEvent): void => {
    this.selectedTabIndex = tabChangeEvent.index;
    this.setAccSummaryTableHeight();
  };

  @HostListener('window:resize', ['$event']) onresize(event) {
    this.setAccSummaryTableHeight();
  }

  // set account table height
  setAccSummaryTableHeight() {
    setTimeout(function () {
      const templateHeight = window.innerHeight - $('.TopSec').outerHeight() - $('.form-sec').outerHeight() - $('.mat-mdc-tab-header').outerHeight() - $('.fulfill-top-sec').outerHeight() - 200;
      $('.activeReturnRequest').css('max-height', templateHeight + 'px');
      $('.draftReturnRequest').css('max-height', templateHeight + 'px');
    }, 100);
  }

  // Get account list
  getAccountData() {
    this.loaderService.setLoaderStatus(true);
    this.dashboardFilter.cropYear = this.headerYear;
    this.dashboardFilter.companyCode = this.headerCompany;
    this.subscription.add(this.cppReturnsService.getAccountList().subscribe(result => {
      this.accountList = result;
      this.loaderService.setLoaderStatus(false);
    }, error => this.loaderService.setLoaderStatus(false)));
  }

  // Search the account details on shipto / Deliverto dropdown
  accountSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.accountName.toLocaleLowerCase().indexOf(term) > -1
      || item.accountNumber.toString().indexOf(term) > -1
      || item.address1.toLocaleLowerCase().indexOf(term) > -1
      || item.city.toLocaleLowerCase().indexOf(term) > -1
      || item.state.toLocaleLowerCase().indexOf(term) > -1
      || item.zipCode.toLocaleLowerCase().indexOf(term) > -1;
  }

  getReturnRequestList() {
    this.loaderService.setLoaderStatus(true);
    var inoculantCode = JSON.parse(this.localStorageService.get(MasterConstants.PRODUCT_LINE_INOCULANT_CODE));
    var inoculantCode2 = JSON.parse(`"${this.localStorageService.get(MasterConstants.PRODUCT_LINE_INOCULANT_CODE2)}"`);
    let accountNumber: number;
    if (this.selectedAccount === undefined || this.selectedAccount === null) {
      accountNumber = 0;
    } else {
      accountNumber = this.selectedAccount;
    }
    if (this.productLine == inoculantCode && this.productLine2 == inoculantCode2) {
      this.filter.productLineFilter = `${this.productLine},${this.productLine2}`;
    }

    this.subscription.add(this.cppReturnsService.getReturnRequestList(this.filter).subscribe((result: any[]) => {
      this.returnRequestDraftList = result.filter(x => x.status === 'DRAFT');
      this.draftRequestDataSource = new MatTableDataSource(this.returnRequestDraftList);
      this.draftRequestDataSource.paginator = this.returnRequestDraftPaginator;
      this.isProcessAccessed && this.draftRequestDataSource.paginator.firstPage();
      this.draftRequestDataSource.sort = this.returnRequestDraftSort;
      this.returnRequestList = result.filter(x => x.status != 'DRAFT');
      const resultant = [];
      this.returnRequestList.reduce(function (res, value) {
        if (!res[value.returnRequestNumber]) {
          res[value.returnRequestNumber] = { ...value }; // TO CLONE
          res[value.returnRequestNumber].total = 0;
          res[value.returnRequestNumber].StatusList = [];
          resultant.push(res[value.returnRequestNumber]);
        }
        res[value.returnRequestNumber].StatusList.push(value.requestStatus);
        return res;
      }, {});

      this.returnRequestDataSource = new MatTableDataSource(resultant);
      this.returnRequestDataSource.paginator = this.returnRequestPaginator;
      this.returnRequestDataSource.paginator.firstPage();
      this.returnRequestDataSource.sort = this.returnRequestSort;

      this.loaderService.setLoaderStatus(false);
    }, error => { this.loaderService.setLoaderStatus(false); }));
  }

  // Create a new Cpp order(navigate to new order screen)
  createNewReturn() {
    var inoculantCode = JSON.parse(this.localStorageService.get(MasterConstants.PRODUCT_LINE_INOCULANT_CODE));
    var inoculantCode2 = JSON.parse(`"${this.localStorageService.get(MasterConstants.PRODUCT_LINE_INOCULANT_CODE2)}"`);
    if (!this.isValidForReturn) {
    } else {
      if (this.productLine == inoculantCode && this.productLine2 == inoculantCode2) {
        this.cppReturnsService.setIsReturnTypeForInoculant(true);
      }
      else {
        this.cppReturnsService.setIsReturnTypeForInoculant(false);
      }
      this.cppReturnsService.setReturnRequestStatus(null);
      this.cppReturnsService.setCppReturnRequestId(+0);
      this.router.navigate(['/cpp-returns/request-products/']);
    }
  }

  // account change
  accountChange($event) {
    if ($event) {
      this.getReturnRequestList();
    }
  }

  // Event fired on clearing selected account from dropdown
  clearAccount() {
    // this.clearAllData();
    this.getReturnRequestList();
  }

  // return sum of amount for draft orders
  getTotalDraftOrdersBalance() {
    return this.returnRequestDraftList.map(t => t.total).reduce((acc, value) => acc + value, 0);
  }

  // return sum of amount for placed orders
  getTotalPlacedOrdersBalance() {
    return this.returnRequestList.map(t => t.total).reduce((acc, value) => acc + value, 0);
  }

  // set the search filter list based on evolveaccountrestriction
  setSearchTypeList() {
    var inoculantCode = JSON.parse(this.localStorageService.get(MasterConstants.PRODUCT_LINE_INOCULANT_CODE));
    var inoculantCode2 = JSON.parse(`"${this.localStorageService.get(MasterConstants.PRODUCT_LINE_INOCULANT_CODE2)}"`);
    const commonSearchTypes = ['Product Name', 'Product Line', 'Item Number', 'Request Date', 'Return ID', 'Customer PO Number', 'By Notification'];
    if (this.isEvolveAccountRestriction) {
      this.searchTypeList = this.productLine == inoculantCode && this.productLine2 == inoculantCode2 ? ['Sold To', 'Account'].concat(commonSearchTypes) : ['Account'].concat(commonSearchTypes);
    }
    else {
      this.searchTypeList = this.productLine == inoculantCode && this.productLine2 == inoculantCode2 ? ['Sold To', 'Account Name', 'Account No'].concat(commonSearchTypes) : ['Account Name', 'Account No'].concat(commonSearchTypes);
    }
    this.selectedValue = this.searchTypeList[0];
  }

  // Reset Page Filter
  resetPageFilter() {
    this.productFilters = {
      'ProductLineId': '',
      'ProductName': null,
      'ItemNo': [],
      'AccountName': null,
      'TxtAccountNo': null,
      'TxtSoldToNo': null,
      'SoldToNo': [],
      'AccountNo': [],
      'FromOrderDate': null,
      'ToOrderDate': null,
      'ReturnRequestNumber': null,
      'Notification': null,
      'ProductLineFilter': null,
      'CustomerPO': null,
      'BranchPlant': null,
    };

    this.filter = {
      'productLineId': '',
      'productName': null,
      'itemNo': null,
      'accountName': null,
      'account': null,
      'fromOrderDate': null,
      'toOrderDate': null,
      'returnRequestNumber': null,
      'processingStatus': null,
      'notification': null,
      'productLineFilter': null,
      'customerPO': null,
      'branchPlant': null,
      'soldTo': null
    };
  }

  // Clear selected filter
  clearFilter(filterValue) {
    const index = this.filterValueList.indexOf(filterValue);
    if (index > -1) {
      this.filterValueList.splice(index, 1);
      // remove product filter
      this.removeSelectedFilter(filterValue);

      if (this.filterValueList.length < 1) {
        this.getReturnRequestList();
      }
      this.setAccSummaryTableHeight();
    }
  }

  validateNumText(numInput) {
    const accountRegx = RegExp('^[0-9, ]+$');
    const isValidNumInput = accountRegx.test(numInput);
    if (!isValidNumInput) {
      this.toastrService.error('Invalid Input.');
      numInput = null;
    }
    return numInput;
  }
  // Validate the search input text
  validateInputText() {
    if (this.productFilters.TxtAccountNo) {
      this.productFilters.TxtAccountNo = this.validateNumText(this.productFilters.TxtAccountNo);
    }
    if (this.productFilters.ReturnRequestNumber) {
      this.productFilters.ReturnRequestNumber = this.validateNumText(this.productFilters.ReturnRequestNumber);
    }
    if (this.productFilters.TxtSoldToNo) {
      this.productFilters.TxtSoldToNo = this.validateNumText(this.productFilters.TxtSoldToNo);
    }
  }

  // Retain Filter Value
  retainFilter(selectedObj: any, type: string) {
    this.validateInputText();
    if (this.filterValueList) {
      this.setAccSummaryTableHeight();
      let selectedIds = '';
      if (selectedObj && selectedObj.selectedValues) {
        const selectedValues = selectedObj.selectedValues as any[];
        if (type == 'ItemNo') {
          selectedValues.forEach(x => { selectedIds = selectedIds + x.value + ','; });
        } else if (type == 'Notification') {
          selectedValues.forEach(x => { selectedIds = selectedIds + x.value + ','; });
        } else if (type == 'ProductLineFilter') {
          selectedValues.forEach(x => { selectedIds = selectedIds + x.id + ','; });
        }
        else {
          selectedValues.forEach(x => { selectedIds = selectedIds + (type == 'AccountNo' ? x.accountNumber : x.id) + ','; });
        }
      }

      switch (type) {
        case 'ItemNo':
          this.filter.itemNo = selectedIds;
          break;
        case 'Notification':
          this.filter.notification = selectedIds;
          break;
        case 'ProductLineFilter':
          this.filter.productLineFilter = selectedIds;
          break;
      }

      // Create filterValueList from Product Filters
      this.filterValueList = [];
      if (this.productFilters) {
        if (this.productFilters.ProductName && this.productFilters.ProductName != '') {
          this.filterValueList.push('Product Name : ' + this.productFilters.ProductName);
          this.filter.productName = this.productFilters.ProductName.trim();
        }

        if (this.productFilters.CustomerPO && this.productFilters.CustomerPO != '') {
          this.filterValueList.push('Customer PO Number : ' + this.productFilters.CustomerPO);
          this.filter.customerPO = this.productFilters.CustomerPO.trim();
        } else {
          this.filter.customerPO = null;
        }

        if (this.productFilters.BranchPlant && this.productFilters.BranchPlant != '') {
          this.filterValueList.push('Branch Plant : ' + this.productFilters.BranchPlant);
          this.filter.branchPlant = this.productFilters.BranchPlant.trim();
        }

        // Set Item No
        if (this.productFilters.ItemNo && this.productFilters.ItemNo.length > 0) {
          var strIno = '';
          this.productFilters.ItemNo.forEach(x => {
            strIno = strIno + x + ', ';
          });
          this.filterValueList.push('Item No : ' + strIno.substr(0, strIno.length - 2));
        }
        // Set Notification
        if (this.productFilters.Notification && this.productFilters.Notification.length > 0) {
          var strIno = '';
          this.productFilters.Notification.forEach(x => {
            strIno = strIno + x + ', ';
          });
          this.filterValueList.push('By Notification : ' + strIno.substr(0, strIno.length - 2));
        }
        // Set ProductLineFilter
        if (this.productFilters.ProductLineFilter && this.productFilters.ProductLineFilter.length > 0) {
          let strPL = '';
          this.productFilters.ProductLineFilter.forEach(x => {
            strPL = strPL + x + ', ';
          });
          this.filterValueList.push('Product Line : ' + strPL.substr(0, strPL.length - 2));
        }

        // text Account No
        if (this.productFilters.TxtAccountNo && this.productFilters.TxtAccountNo != '') {
          this.filterValueList.push('Account No : ' + this.productFilters.TxtAccountNo);
          this.filter.account = this.productFilters.TxtAccountNo.trim();
        }
        else if (this.productFilters.AccountNo && this.productFilters.AccountNo.length > 0) {
          let strAct = '';
          this.productFilters.AccountNo.forEach(x => {
            strAct = strAct + x + ', ';
          });

          if (this.isEvolveAccountRestriction) {
            this.filterValueList.push('Account : ' + strAct.substr(0, strAct.length - 2));
          }
          else {
            this.filterValueList.push('Account No : ' + strAct.substr(0, strAct.length - 2));
          }

          if (this.productFilters.AccountNo == -1) {
            this.filter.account = '-1';
          }
          else {
            this.filter.account = strAct;
          }
        }
        else {
          this.filter.account = null;
        }
        // text Sold To
        if (this.productFilters.TxtSoldToNo && this.productFilters.TxtSoldToNo != '') {
          this.filterValueList.push('Sold To : ' + this.productFilters.TxtSoldToNo);
          this.filter.soldTo = this.productFilters.TxtSoldToNo.trim();
        }
        else if (this.productFilters.SoldToNo && this.productFilters.SoldToNo.length > 0) {
          let strAct = '';
          this.productFilters.SoldToNo.forEach(x => {
            strAct = strAct + x + ', ';
          });
          this.filterValueList.push('Sold To : ' + strAct.substr(0, strAct.length - 2));

          if (this.productFilters.SoldToNo == -1) {
            this.filter.soldTo = '-1';
          }
          else {
            this.filter.soldTo = strAct;
          }
        }
        else {
          this.filter.soldTo = null;
        }
        // Account Name
        if (this.productFilters.AccountName && this.productFilters.AccountName != '') {
          this.filterValueList.push('Account Name : ' + this.productFilters.AccountName);
          this.filter.accountName = this.productFilters.AccountName.trim();
        }
        else {
          this.filter.accountName = null;
        }

        // Web Order Number
        if (this.productFilters.ReturnRequestNumber && this.productFilters.ReturnRequestNumber != '') {
          this.filterValueList.push('Return ID : ' + this.productFilters.ReturnRequestNumber);
          this.filter.returnRequestNumber = this.productFilters.ReturnRequestNumber.trim();
        } else {
          this.filter.returnRequestNumber = null;
        }

        if (this.productFilters.FromOrderDate
          && this.productFilters.FromOrderDate != null
          && this.productFilters.ToOrderDate
          && this.productFilters.ToOrderDate != null) {
          this.filterValueList.push('Request Date : (' + this.datePipe.transform(this.productFilters.FromOrderDate, 'MM/dd/yyyy') + ') - (' + this.datePipe.transform(this.productFilters.ToOrderDate, 'MM/dd/yyyy') + ')');
          this.filter.fromOrderDate = new Date(this.productFilters.FromOrderDate).toDateString();
          this.filter.toOrderDate = new Date(this.productFilters.ToOrderDate).toDateString();
        }
      }
      this.setAccSummaryTableHeight();
    }
  }

  // To remove/clear selected chip search filter
  removeSelectedFilter(filterValue) {
    const removeFilter = filterValue.split(' : ');
    const index = -1;
    switch (removeFilter[0].trim()) {
      case 'Item No':
        this.productFilters.ItemNo = null;
        this.filter.itemNo = null;
        break;
      case 'Product Line':
        this.productFilters.ProductLineFilter = null;
        this.filter.productLineFilter = null;
        break;
      case 'Product Name':
        this.productFilters.ProductName = null;
        this.filter.productName = null;
        break;
      case 'Customer PO Number':
        this.productFilters.CustomerPO = null;
        this.filter.customerPO = null;
        break;
      case 'Branch Plant':
        this.productFilters.BranchPlant = null;
        this.filter.branchPlant = null;
        break;
      case 'Account No':
        if (this.isEvolveAccountRestriction) {
          this.productFilters.AccountNo = [];
        }
        else {
          this.productFilters.TxtAccountNo = null;
        }
        this.productFilters.AccountNo = [];
        this.filter.account = null;
        break;
      case 'Account':
        if (this.isEvolveAccountRestriction) {
          this.productFilters.AccountNo = [];
        }
        else {
          this.productFilters.TxtAccountNo = null;
        }
        this.productFilters.AccountNo = [];
        this.filter.account = null;
        break;
      case 'Sold To':
        this.productFilters.SoldToNo = [];
        this.filter.soldTo = null;
        this.productFilters.TxtSoldToNo = null;
        break;
      case 'Account Name':
        this.productFilters.AccountName = null;
        this.filter.accountName = null;
        break;
      case 'Return ID':
        this.productFilters.ReturnRequestNumber = null;
        this.filter.returnRequestNumber = null;
        break;

      case 'Request Date':
        this.productFilters.FromOrderDate = null;
        this.productFilters.ToOrderDate = null;
        this.filter.fromOrderDate = null;
        this.filter.toOrderDate = null;
        this.fromOrderDateFilter = '';
        this.toOrderDateFilter = '';
        break;

      case 'By Notification':
        this.productFilters.Notification = null;
        this.filter.notification = null;
        break;

      default:
        break;
    }
  }

  // Clear all filter
  clearAllFilter() {
    this.filterValueList = new Array();
    this.resetPageFilter();
    this.validateOrderDateFilter('clearAll', '');
    this.getReturnRequestList();
    this.setAccSummaryTableHeight();
  }

  // validate the order date filter on search filters
  validateOrderDateFilter(contextFrom, $event) {
    if (contextFrom == 'fromOrderDate') {
      fromDate = new Date($event.value);
      if (this.productFilters.ToOrderDate) {
        var toDate = new Date(this.productFilters.ToOrderDate);
        this.fromOrderDateFilter = (d: Date): boolean => {
          const calendarDate = d;
          return calendarDate <= toDate;
        };
      }
      this.toOrderDateFilter = (d: Date): boolean => {
        const calendarDate = d;
        return calendarDate >= fromDate;
      };
    }
    else if (contextFrom == 'toOrderDate') {
      toDate = new Date($event.value);
      this.fromOrderDateFilter = (d: Date): boolean => {
        const calendarDate = d;
        return calendarDate <= toDate;
      };
      if (this.productFilters.FromOrderDate) {
        var fromDate = new Date(this.productFilters.FromOrderDate);
        this.toOrderDateFilter = (d: Date): boolean => {
          const calendarDate = d;
          return calendarDate >= fromDate;
        };
      }
    }
    else if (contextFrom == 'clearAll') {
      this.fromOrderDateFilter = '';
      this.toOrderDateFilter = '';
    }
  }

  // Navigate to selected order detail
  navigateOrderDetail(obj: any, tabType: string) {
    let accountNumber = 0;
    var inoculantCode = JSON.parse(this.localStorageService.get(MasterConstants.PRODUCT_LINE_INOCULANT_CODE));
    var inoculantCode2 = JSON.parse(`"${this.localStorageService.get(MasterConstants.PRODUCT_LINE_INOCULANT_CODE2)}"`);
    if (obj) {
      if (this.selectedAccount === undefined || this.selectedAccount === null) {
        accountNumber = 0;
      } else {
        accountNumber = this.selectedAccount;
      }
      this.loaderService.setLoaderStatus(true);
      // this.cppReturnsService.setSelectedProductLine(this.cppReturnsService.getProductLineValueById(obj.productLine));
      this.cppReturnsService.setReturnRequestStatus(obj.status);
      this.cppReturnsService.setCppReturnRequestId(+obj.returnRequestCppId);
      if (this.productLine == inoculantCode && this.productLine2 == inoculantCode2) {
        this.cppReturnsService.setIsReturnTypeForInoculant(true);
      }
      else {
        this.cppReturnsService.setIsReturnTypeForInoculant(false);
      }
      if (this.productLine != inoculantCode && this.productLine2 != inoculantCode2) {
        if (tabType == 'active') {
          this.router.navigate(['/cpp-returns/products-confirmation', obj.returnRequestCppId]);
        } else {
          this.router.navigate(['/cpp-returns/request-products', obj.returnRequestCppId]);
        }
      }
      else {
        if (tabType == 'active') {
          if (obj.status == "PENDING" && this.isApprovalAccess) {
            this.router.navigate(['/cpp-returns/products-approve-reject', obj.returnRequestCppId]);
          }
          else {
            this.router.navigate(['/cpp-returns/products-confirmation', obj.returnRequestCppId]);
          }
        } else {
          this.router.navigate(['/cpp-returns/request-products', obj.returnRequestCppId]);
        }
      }
      this.loaderService.setLoaderStatus(false);
    }
  }

  // Delete draft request
  deleteOrder(order: any) {
    if (order) {
      const dialogRef = this.matDialog.open(ConfirmDialogComponent, {
        disableClose: true,
        width: '400px',
        data: { title: 'Delete Draft Request', message: 'Do you want to delete this saved request?', labelYes: 'Yes', labelNo: 'No', dialogType: 'confirm' }
      });
      this.subscription.add(dialogRef.afterClosed().subscribe(result => {
        // If user selected Yes
        if (result == true) {
          this.loaderService.setLoaderStatus(true);
          this.subscription.add(this.cppReturnsService.deleteRequest(order.returnRequestCppId).subscribe(result => {
            if (result) {
              this.toastrService.success('Draft order deleted successfully.');
              this.getReturnRequestList();
            }
            this.loaderService.setLoaderStatus(false);
          }, error => this.loaderService.setLoaderStatus(false)));
        }
      }));
    }
  }

  // Get Banner Message
  getBannerMessage() {
    this.loaderService.setLoaderStatus(true);
    this.subscription.add(this.cppReturnsService.getBannerMessage().subscribe((result: any) => {
      this.bannerMessage = result.message;
      this.isValidForReturn = result.status;
      this.loaderService.setLoaderStatus(false);
    }, error => {
      this.loaderService.setLoaderStatus(false);
    }));
  }

  viewOrderToInvoice(element) {
    this.loaderService.setLoaderStatus(true);
    this.subscription.add(this.cppReturnsService.checkOTIOrders(element.accountNumber, element.purchaseOrderNumber).subscribe(result => {
      if (result) {
        //this.localStorageService.set(MasterConstants.OTI_CUSTOMERPO, element.purchaseOrderNumber);
        //this.localStorageService.set(MasterConstants.OTI_ACCOUNTNUMBER, element.accountNumber);
        //this.router.navigate(['/cc/landing-data']);
        this.filters.account = element.accountNumber;
        this.filters.dateInDays = 0;
        this.filters.fromOrderDate = element.orderCreateDate !== null ? new Date(element.orderCreateDate) : null;
        this.filters.toOrderDate = new Date();
        this.filters.customerPO = element.purchaseOrderNumber;
        this.filters.orderStatus = null;
        this.filters.orderStatusText = "ALL";
        this.filters.productLineSegment = 'CPP';
        this.filters.dateRangeText = this.filters.fromOrderDate != null && this.filters.toOrderDate != null ? this.datePipe.transform(this.filters.fromOrderDate, 'MM/dd/yyyy')
          + ' - ' + this.datePipe.transform(this.filters.toOrderDate, 'MM/dd/yyyy') : "";
        this.otiService.setFilters(this.filters);
        this.router.navigate(['/order/dashboard']);
      } else {
        this.toastrService.error('Order not found. Please check back.');
      }
      this.loaderService.setLoaderStatus(false);
    }, error => this.loaderService.setLoaderStatus(false)));
  }

  public getStatusText(status: string): string {
    status = status.toUpperCase();
    let retVal = status;
    if (status === 'ACCEPTED') {
      retVal = 'SUBMITTED';
    } else if (status === 'PLANNING' || status === 'SHIPPED') {
      retVal = 'APPROVED';
    }
    return retVal;
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  getProductLineList() {
    var inoculantCode = JSON.parse(this.localStorageService.get(MasterConstants.PRODUCT_LINE_INOCULANT_CODE));
    var inoculantCode2 = JSON.parse(`"${this.localStorageService.get(MasterConstants.PRODUCT_LINE_INOCULANT_CODE2)}"`);
    this.loaderService.setLoaderStatus(true);
    this.subscription.add(this.cppReturnsService.getProductLineList().subscribe((result) => {
      if (this.productLine != inoculantCode && this.productLine2 != inoculantCode2) {
        this.productLineList = result.filter(x => x.id != inoculantCode && this.productLine2 != inoculantCode2);
      } else {
        this.productLineList = result.filter(x => x.id == inoculantCode);
      }
      this.loaderService.setLoaderStatus(false);
    }, error => { this.loaderService.setLoaderStatus(false); }));
  }

  // for adding product
  addProduct() {
    this.cppReturnAddProductSliderModelService.activeSlider('AddCppReturnProductSlider');
  }

  public export() {

    const exportData = [];
    var inoculantCode = JSON.parse(this.localStorageService.get(MasterConstants.PRODUCT_LINE_INOCULANT_CODE));
    var inoculantCode2 = JSON.parse(`"${this.localStorageService.get(MasterConstants.PRODUCT_LINE_INOCULANT_CODE2)}"`);
    this.loaderService.setLoaderStatus(true);

    if (this.selectedTabIndex === 0 && this.returnRequestList && this.returnRequestList.length > 0) {
      this.subscription.add(this.cppReturnsService.getReturnRequestReport(this.filter).subscribe((result: any[]) => {
        const exportData = [];
        if (result && result.length > 0) {
          this.loaderService.setLoaderStatus(true);
          result.filter(x => x.status !== 'DRAFT').forEach(x => {
            const dataToPush = {
              'Return Number': x.returnRequestNumber,
              'Account Name': x.accountName,
              'Account#': x.accountNumber,
              'Account Address': x.accountAddress1,
              'Account City': x.accountCity,
              'Account State': x.accountState
            };
            if (this.productLine == inoculantCode && this.productLine2 == inoculantCode2) {
              dataToPush['Sold To#'] = x.soldToNumber;
              dataToPush['Sold To Name'] = x.soldToName;
              dataToPush['Sold To Address'] = x.soldToAddress1;
              dataToPush['Sold To City'] = x.soldToCity;
              dataToPush['Sold To State'] = x.soldToState;
            }
            dataToPush['Customer PO#'] = x.purchaseOrderNumber;
            dataToPush['Request Date'] = this.datePipe.transform(x.orderCreateDate, MasterConstants.DATE_MMDDYYYY);
            dataToPush['Status'] = x.status;
            dataToPush['Product Line'] = x.productLine;
            dataToPush['Item Number'] = x.itemNumber;
            dataToPush['Item Description'] = x.productName;
            dataToPush['Package Size'] = x.packageSize;
            dataToPush['Requested Units'] = x.returnUnits;
            dataToPush['Order UOM'] = x.orderUOM;
            dataToPush['Vendor'] = x.vendor;
            exportData.push(dataToPush);
          });
          this.excelService.exportAsExcelFile(exportData, 'ActiveCPPReturns');
          this.loaderService.setLoaderStatus(false);
        }
      }));
    } else if (this.selectedTabIndex === 1 && this.returnRequestDraftList && this.returnRequestDraftList.length > 0) {
      this.subscription.add(this.cppReturnsService.getReturnRequestReport(this.filter).subscribe((result: any[]) => {
        const exportData = [];
        if (result && result.length > 0) {
          this.loaderService.setLoaderStatus(true);
          result.filter(x => x.status === 'DRAFT').forEach(x => {
            const dataToPush = {
              'Return Number': x.returnRequestNumber,
              'Account Name': x.accountName,
              'Account#': x.accountNumber,
              'Account Address': x.accountAddress1,
              'Account City': x.accountCity,
              'Account State': x.accountState
            };
            if (this.productLine == inoculantCode && this.productLine2 == inoculantCode2) {
              dataToPush['Sold To#'] = x.soldToNumber;
              dataToPush['Sold To Name'] = x.soldToName;
              dataToPush['Sold To Address'] = x.soldToAddress1;
              dataToPush['Sold To City'] = x.soldToCity;
              dataToPush['Sold To State'] = x.soldToState;
            }
            dataToPush['Customer PO#'] = x.purchaseOrderNumber;
            dataToPush['Draft Date'] = this.datePipe.transform(x.orderCreateDate, MasterConstants.DATE_MMDDYYYY);
            dataToPush['Product Line'] = x.productLine;
            dataToPush['Item Number'] = x.itemNumber;
            dataToPush['Item Description'] = x.productName;
            dataToPush['Package Size'] = x.packageSize;
            dataToPush['Requested Units'] = x.returnUnits;
            dataToPush['Order UOM'] = x.orderUOM;
            dataToPush['Vendor'] = x.vendor;
            exportData.push(dataToPush);
          });
          this.excelService.exportAsExcelFile(exportData, 'DraftsCPPReturns');
          this.loaderService.setLoaderStatus(false);
        }
      }));
    }
  }

  getProcessAccess() {
    this.loaderService.setLoaderStatus(true);
    var inoculant = `${this.productLine},${this.productLine2}`;
    this.subscription.add(this.cppReturnsService.getReturnAccessRequest(inoculant).subscribe((result: any) => {
      this.isProcessAccessed = result;
      this.loaderService.setLoaderStatus(false);
    }, error => {
      this.loaderService.setLoaderStatus(false);
    }));
  }
}
